/**
 * Updates document title and meta tags for SEO
 * @param {string} title - Page title
 * @param {string} description - Page description (optional)
 */
export const updatePageMeta = (title, description = 'UI/UX Designer creating thoughtful digital experiences. Portfolio of Stephanie Zhang.') => {
  // Update document title
  document.title = title;

  // Update or create meta description
  let metaDescription = document.querySelector('meta[name="description"]');
  if (!metaDescription) {
    metaDescription = document.createElement('meta');
    metaDescription.setAttribute('name', 'description');
    document.head.appendChild(metaDescription);
  }
  metaDescription.setAttribute('content', description);

  // Update Open Graph tags
  updateOpenGraphTag('og:title', title);
  updateOpenGraphTag('og:description', description);

  // Update Twitter Card tags
  updateMetaTag('twitter:title', title);
  updateMetaTag('twitter:description', description);
};

/**
 * Helper function to update or create Open Graph meta tags
 */
const updateOpenGraphTag = (property, content) => {
  let tag = document.querySelector(`meta[property="${property}"]`);
  if (!tag) {
    tag = document.createElement('meta');
    tag.setAttribute('property', property);
    document.head.appendChild(tag);
  }
  tag.setAttribute('content', content);
};

/**
 * Helper function to update or create meta tags
 */
const updateMetaTag = (name, content) => {
  let tag = document.querySelector(`meta[name="${name}"]`);
  if (!tag) {
    tag = document.createElement('meta');
    tag.setAttribute('name', name);
    document.head.appendChild(tag);
  }
  tag.setAttribute('content', content);
};
